import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FileFlatNode, SeoPageDO, SeoSiteMapDO } from '../model/site-tree.model';
import { arrayNotEmpty, isDefined } from '../../../../../../../utils/utils';

@Injectable()
export class SiteTreeFileDatabaseService {
  dataChange = new BehaviorSubject<FileFlatNode[]>([]);

  get data(): FileFlatNode[] {
    return this.dataChange.value;
  }

  constructor() {}

  initialize(pages: SeoPageDO[]) {
    if (arrayNotEmpty(pages)) {
      this.dataChange.next(this.buildFileTree(pages, 0));
    }
  }

  buildFileTree(pages: SeoPageDO[], level: number, parentId: string = '0'): FileFlatNode[] {
    return pages.reduce<FileFlatNode[]>((accumulator, page, idx) => {
      const node = {} as FileFlatNode;
      node.id = `${page.id}`;
      // node.filename = page.title;
      node.entity = page;

      if (arrayNotEmpty(page.children)) {
        node.children = this.buildFileTree(page.children, level + 1, node.id);
      }

      return accumulator.concat(node);
    }, []);
  }

  // initialize(treeData: any) {
  //     // Parse the string to json object.
  //     const dataObject = JSON.parse(treeData);
  //
  //     // Build the tree nodes from Json object. The result is a list of `FileNode` with nested
  //     //     file node as children.
  //     const data = this.buildFileTree(dataObject, 0);
  //
  //     // Notify the change.
  //     this.dataChange.next(data);
  // }

  // /**
  //  * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
  //  * The return value is the list of `FileNode`.
  //  */
  // buildFileTree(obj: { [key: string]: any }, level: number, parentId: string = '0'): FileNode[] {
  //     return Object.keys(obj).reduce<FileNode[]>((accumulator, key, idx) => {
  //         const value = obj[key];
  //         const node = {} as  FileNode;
  //         node.filename = key;
  //         /**
  //          * Make sure your node has an id so we can properly rearrange the tree during drag'n'drop.
  //          * By passing parentId to buildFileTree, it constructs a path of indexes which make
  //          * it possible find the exact sub-array that the node was grabbed from when dropped.
  //          */
  //         node.id = `${parentId}/${idx}`;
  //
  //         if (value != null) {
  //             if (typeof value === 'object') {
  //                 node.children = this.buildFileTree(value, level + 1, node.id);
  //             } else {
  //                 node.type = value;
  //             }
  //         }
  //
  //         return accumulator.concat(node);
  //     }, []);
  // }
}
